import { createHttpLink } from '@apollo/client';

const httpLink = createHttpLink({ uri: process.env.REACT_APP_GRAPHQL_API_URL });

export default httpLink;
